import AmenityList from './AmenityList';

export default AmenityList;
